import React from 'react';
import { XCircle, CheckCircle, ShieldCheck, TrendingDown, Zap } from 'lucide-react';
import { useLocale } from '../utils/locale';
export function TwoPathsSection() {
  const locale = useLocale();
  const isAR = locale === 'ar';
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-312">
      <div className="max-w-5xl mx-auto" data-id="element-313">
        <div className="text-center mb-8 md:mb-16" data-id="element-314">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-315">
            En este momento estás frente a dos caminos:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-0 mb-8 md:mb-16 relative" data-id="element-316">
          {/* Divider */}
          <div className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 flex-col items-center justify-center z-10" data-id="element-317">
            <div className="w-0.5 h-full bg-navy/10" data-id="element-318"></div>
            <div className="absolute top-1/2 -translate-y-1/2 bg-background px-3 py-2 text-navy/40 font-bold text-sm tracking-wider uppercase" data-id="element-319">
              VS
            </div>
          </div>

          {/* Path A — Frustration */}
          <div className="bg-white p-8 md:p-10 rounded-l-2xl md:rounded-r-none rounded-2xl md:rounded-bl-2xl border border-red-200 shadow-sm relative opacity-85" data-id="element-320">
            <div className="absolute top-4 right-4 bg-red-50 text-red-400 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-321">
              Estancamiento
            </div>
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-red-100" data-id="element-322">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center" data-id="element-323">
                <TrendingDown className="w-6 h-6 text-red-300" data-id="element-324" />
              </div>
              <div data-id="element-325">
                <h3 className="text-2xl font-bold text-navy/80" data-id="element-326">Camino A</h3>
                <span className="text-sm text-red-300 font-medium" data-id="element-327">
                  El Camino de la Frustración
                </span>
              </div>
            </div>
            <ul className="space-y-4 text-navy/60" data-id="element-328">
              <li className="flex items-start gap-3" data-id="element-329">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-330" />
                <span data-id="element-331">
                  {isAR ? 'Cerrás' : 'Cierras'} esta página y{' '}
                  <strong className="text-navy/70" data-id="element-332">
                    {isAR ? 'seguís haciendo' : 'sigues haciendo'} lo "correcto"
                  </strong>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-333">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-334" />
                <span data-id="element-335">
                  {isAR ? 'Seguís pidiéndole' : 'Sigues pidiéndole'}{' '}
                  <strong className="text-navy/70" data-id="element-336">
                    energía prestada al café para sobrevivir
                  </strong>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-337">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-338" />
                <span data-id="element-339">
                  {isAR ? 'Aceptás' : 'Aceptas'} que el{' '}
                  <strong className="text-navy/70" data-id="element-340">cansancio</strong> y la{' '}
                  <strong className="text-navy/70" data-id="element-341">niebla mental</strong> son
                  "normales a tu edad".
                </span>
              </li>
            </ul>
          </div>

          {/* Separator on mobile */}
          <div className="flex md:hidden items-center justify-center py-4" data-id="element-342">
            <div className="h-0.5 w-16 bg-navy/10" data-id="element-343"></div>
            <span className="px-3 text-navy/40 font-bold text-sm" data-id="element-344">VS</span>
            <div className="h-0.5 w-16 bg-navy/10" data-id="element-345"></div>
          </div>

          {/* Path B — Metabolic Reset */}
          <div className="bg-white p-8 md:p-10 rounded-r-2xl md:rounded-l-none rounded-2xl md:rounded-tr-2xl border-2 border-accent shadow-xl relative" data-id="element-346">
            <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-347">
              Recomendado
            </div>
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-accent/20" data-id="element-348">
              <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center" data-id="element-349">
                <Zap className="w-6 h-6 text-accent" data-id="element-350" />
              </div>
              <div data-id="element-351">
                <h3 className="text-2xl font-bold text-navy" data-id="element-352">Camino B</h3>
                <span className="text-sm text-accent font-medium" data-id="element-353">
                  El Reinicio Metabólico
                </span>
              </div>
            </div>
            <ul className="space-y-4 text-navy/90 font-medium" data-id="element-354">
              <li className="flex items-start gap-3" data-id="element-355">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-356" />
                <span data-id="element-357">
                  {isAR ? 'Probás' : 'Pruebas'} algo diferente durante solo{' '}
                  <strong className="text-navy" data-id="element-358">72 horas</strong>.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-359">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-360" />
                <span data-id="element-361">
                  <strong className="text-navy" data-id="element-362">
                    {isAR ? 'Limpiás' : 'Limpias'} tu sistema
                  </strong>{' '}
                  y{' '}
                  <span className="text-accent font-semibold" data-id="element-363">
                    {isAR ? 'recuperás' : 'recuperas'} tu enfoque
                  </span>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-364">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-365" />
                <span data-id="element-366">
                  Ves cómo tu cuerpo{' '}
                  <span className="text-accent font-semibold" data-id="element-367">
                    responde cuando {isAR ? 'dejás' : 'dejas'} de atacarlo
                  </span>
                  .
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Guarantee Box */}
        <div className="bg-amber/10 border border-amber/30 p-8 md:p-10 rounded-2xl max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-368">
          <ShieldCheck className="w-20 h-20 text-amber flex-shrink-0" data-id="element-369" />
          <div data-id="element-370">
            <h4 className="text-xl font-bold text-navy mb-3" data-id="element-371">
              Garantía de Satisfacción de 7 Días
            </h4>
            <p className="text-navy/80 leading-relaxed" data-id="element-372">
              {isAR ? 'Si elegís' : 'Si eliges'} el Camino B, yo asumo todo el
              riesgo. {isAR ? 'Tenés' : 'Tienes'} una semana entera para evaluar
              el manual. Si después de aplicar el protocolo de{' '}
              <strong className="text-navy" data-id="element-373">72 horas</strong>{' '}
              {isAR ? 'no notás' : 'no notas'} un cambio real en tu{' '}
              <strong className="text-navy" data-id="element-374">claridad mental</strong> y tus
              niveles de energía, {isAR ? 'me mandás' : 'me mandas'} un mensaje
              y te devuelvo el 100% de tu inversión. Sin preguntas incómodas y
              sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}